import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler,
    Text,
    TouchableWithoutFeedback, Image
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import AdapterListOperatorApply from "./adapters/AdapterListOperatorApply";
import store from "../../../../redux/store";
import {
    serviceActionAddSubList,
    serviceActionListFilter,
    serviceActionSuccess,
    serviceActionError,
    serviceActionSetLike,
    serviceActionSetDisplayImage,
    serviceActionSetDisplayComment,
    serviceActionSetComment, serviceActionAddFile
} from "./action/ActionGalleryServiceScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";
import HMTextInput from "../../../../customviews/HMTextInput";
import * as NavigationService from "../../../../redux/NavigationService";
import HMButton from "../../../../customviews/HMButton";
import HMIcon from "../../../../customviews/HMIcon";
import HMModalSearch from "../../../../customviews/HMModalSearch";
import HMSwiper from "../../../../customviews/swiper/HMSwiper";
import HMImageView from "../../../../customviews/HMImageView";
import HMModal from "../../../../customviews/modal/HMModal";
import ImagePicker from "react-native-image-crop-picker";
import {Tools} from "../../../../tools/Tools";
import axios from "axios";
import HMAlert from "../../../../customviews/HMAlert";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";

let container = null;
let backClickCount_value = 0;


/*
*
* const some_array = [...this.state.some_array]
some_array[indexHere] = yourValue
this.setState({some_array:some_array})
* */
import {RecyclerListView, DataProvider, LayoutProvider} from "recyclerlistview";

let checkParams = null;
import importFirebase from "../../../../importCalss/firebase/importFirebase";
import HMRecycleView from "../../../../customviews/HMRecycleView";
import {isMobile} from "react-device-detect";


let firebase = importFirebase;
export default class GalleryServiceScreen extends Component {
    constructor(props) {
        super(props);
        // global._refreshListOpertor = true;


        container = this;
        checkParams = (props.route && props.route.params && props.route.params.header);
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 1000 ? 2 : 1;

        }

        if (Platform.OS === "android") {

            //firebase = require("react-native-firebase")
            // alert(firebase)

        }
        this.state = {
            checkCountRequest: 0,
            canChangeSize: false,

            dataProvider: new DataProvider((r1, r2) => {
                return r1 !== r2;
            }),
            layoutProvider: new LayoutProvider(
                () => {
                    return 'VSEL'; //Since we have just one view type
                },
                (type, dim, index) => {
                    switch (type) {
                        case 'VSEL':
                            dim.width = viewportWidth;
                            dim.height = 1;
                            //dim.width = 0;
                            // if (index % 3 === 0) {
                            //     dim.width = 3 * columnWidth;
                            //     dim.height = 300;
                            // } else if (index % 2 === 0) {
                            //     dim.width = 2 * columnWidth;
                            //     dim.height = 250;
                            // } else {
                            //     dim.width = columnWidth;
                            //     dim.height = 250;
                            // }
                            break;
                        default:
                            dim.width = 0;
                            dim.height = 0;
                    }
                }
            ),


            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            //  textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,


            /* dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                 name: 'در دست اقدام',
                 id: 2
             }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                 name: 'تایید واحد',
                 id: 5
             },],
             textCondition: null,
             arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                 name: 'تکراری در دست اقدام',
                 id: 3
             }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],*/
            Condition: {id: 0, value: "وضعیت پیام"},

            // arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            //   dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null,
            showModal: false,

            list: [
                {
                    id: 1,
                    like: false,
                    files: [
                        {
                            id: 1,
                            image: "https://media.tahlilbazaar.com/d/2020/09/30/3/43418.jpg",
                            display: false
                        },
                        {
                            id: 2,
                            image: "http://media.sarpoosh.com/images/9709/97-09-c07-634.jpg",
                            display: true
                        },
                        {
                            id: 3,
                            image: "https://media.mehrnews.com/d/2016/08/10/3/2168553.jpg?ts=1486462047399",
                            display: true
                        },
                    ],
                    lastWork: [
                        {
                            id: 10,
                            title: "شهروند",
                            comment: "رسیدگی به این کوچه افتضاح است رسیدگی شود",
                            display: false
                        },
                        {
                            id: 11,
                            title: "137 منطقه",
                            comment: "بازرسی شد و گفته شهروند صحیح است",
                            display: true
                        },
                        {
                            id: 12,
                            title: "مجری",
                            comment: "نظافت کامل انجام شد و تذکرات لازم و مس",
                            display: false
                        },
                        {
                            id: 13,
                            title: "رضایت مندی",
                            comment: "شهروند از عملیات رضایت ندارد",
                            display: true
                        },
                        {
                            id: 14,
                            title: "بازرسی",
                            comment: "عملیات مجری مورد تایید است",
                            display: true
                        },
                    ]
                },
                {
                    id: 2,
                    like: true,
                    files: [
                        {
                            id: 1,
                            image: "https://media.tahlilbazaar.com/d/2020/09/30/3/43418.jpg",
                            display: true
                        },
                        {
                            id: 2,
                            image: "http://media.sarpoosh.com/images/9709/97-09-c07-634.jpg",
                            display: true
                        },
                        {
                            id: 3,
                            image: "https://media.mehrnews.com/d/2016/08/10/3/2168553.jpg?ts=1486462047399",
                            display: true
                        },
                    ],
                    lastWork: [
                        {
                            id: 10,
                            title: "شهروند",
                            comment: "رسیدگی به این کوچه افتضاح است رسیدگی شود",
                            display: true
                        },
                        {
                            id: 11,
                            title: "137 منطقه",
                            comment: "بازرسی شد و گفته شهروند صحیح است",
                            display: true
                        },
                        {
                            id: 12,
                            title: "مجری",
                            comment: "نظافت کامل انجام شد و تذکرات لازم و مس",
                            display: true
                        },
                        {
                            id: 13,
                            title: "رضایت مندی",
                            comment: "شهروند از عملیات رضایت ندارد",
                            display: true
                        },
                        {
                            id: 14,
                            title: "بازرسی",
                            comment: "عملیات مجری مورد تایید است",
                            display: true
                        },
                    ]
                },
            ]

        };
        container = this;

        //
        // this.props.navigation.addListener('focus', () => {
        //         if (global._refreshListOpertor) {
        //             store.dispatch(serviceActionListFilter([]))
        //             props.callserviceActionRefresh();
        //             this.getData(1)
        //             global._refreshListOpertor = false
        //         }
        //
        //     }
        // )
        // )
        this.props.navigation.addListener('focus', () => {


                this.setState({
                    canChangeSize: true
                })
            }
        )
        this.props.navigation.addListener('blur', () => this.setState({
                canChangeSize: false
            })
        )
    }

    state = {
        show: false
    };

    componentWillReceiveProps(props) {

        props.results && props.results.length > 0 && this.state.Once ?
            this.setState({
                    Once: false
                },
                () => {
                    if (firebase)
                        this.goDetailsOpenNotif()

                }
            )
            :
            null
    }

    /*    async componentDidMount() {

            const channel = new firebase.notifications.Android.Channel(
                'channelId',
                'Channel Name',
                firebase.notifications.Android.Importance.Max
            ).setDescription('A natural description of the channel');
            firebase.notifications().android.createChannel(channel);

            // the listener returns a function you can use to unsubscribe
            this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                if (Platform.OS === 'android') {
                    const localNotification = new firebase.notifications.Notification({
                        sound: 'default',
                        show_in_foreground: true,
                    }).setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .android.setChannelId('channelId') // e.g. the id you chose above
                        .android.setSmallIcon('logo') // create this icon in Android Studio
                        .android.setColor('#000000') // you can set a color here
                        .android.setPriority(firebase.notifications.Android.Priority.High);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));

                }
                else if (Platform.OS === 'ios') {

                    const localNotification = new firebase.notifications.Notification()
                        .setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .ios.setBadge(notification.ios.badge);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));
                }

                if (notification && notification.data && notification.data.typeOperation === '1') {
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }

            });
        }*/

    async componentDidMount() {

        // this.setState({
        //     layoutProvider: new LayoutProvider(
        //         () => {
        //             return 'VSEL'; //Since we have just one view type
        //         },
        //         (type, dim, index) => {
        //             const columnWidth = this.state.viewportWidth;
        //             switch (type) {
        //                 case 'VSEL':
        //                     dim.width = columnWidth;
        //                     dim.height = 1;
        //                     //dim.width = 0;
        //                     // if (index % 3 === 0) {
        //                     //     dim.width = 3 * columnWidth;
        //                     //     dim.height = 300;
        //                     // } else if (index % 2 === 0) {
        //                     //     dim.width = 2 * columnWidth;
        //                     //     dim.height = 250;
        //                     // } else {
        //                     //     dim.width = columnWidth;
        //                     //     dim.height = 250;
        //                     // }
        //                     break;
        //                 default:
        //                     dim.width = 0;
        //                     dim.height = 0;
        //             }
        //         }
        //     ),
        // })
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 1000 ? 2 : 1,
                    },
                )


            })


        let checkGetData = true;

        var {checkCountRequest} = this.state;

        let City = this.props.DataSplashScreen?.City;
        if (!Tools.CheckValue(City) && (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) {
            this.setState({
                checkCountRequest: this.state.checkCountRequest + 1
            })
            NavigationService.navigateParams("ListCityScreen");

        }
        else {
            store.dispatch(serviceActionListFilter([]))
            this.props.callserviceActionRefresh();
            this.getData(1)
        }


        this.props.navigation.addListener('focus', async () => {


                if (this.state.checkCountRequest > 0) {
                    checkGetData = false;
                    let City = this.props.DataSplashScreen?.City;

                    //if (!this.props.DataSplashScreen?.City) {
                    if (!Tools.CheckValue(City) && (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) {
                      //  NavigationService.navigateParams("ListCityScreen");
                        NavigationService.Pop();

                    }
                    else {
                        store.dispatch(serviceActionListFilter([]))
                        this.props.callserviceActionRefresh();
                        this.getData(1)
                    }
                }

            }
        )
        this.props.navigation.addListener('blur', () => {
            }
        )


        // store.dispatch(serviceActionSuccess([
        //     {
        //         id: 1,
        //         like: false,
        //         files: [
        //             {
        //                 id: 1,
        //                 image: "https://media.tahlilbazaar.com/d/2020/09/30/3/43418.jpg",
        //                 display: false
        //             },
        //             {
        //                 id: 2,
        //                 image: "http://media.sarpoosh.com/images/9709/97-09-c07-634.jpg",
        //                 display: true
        //             },
        //             {
        //                 id: 3,
        //                 image: "https://media.mehrnews.com/d/2016/08/10/3/2168553.jpg?ts=1486462047399",
        //                 display: true
        //             },
        //         ],
        //         lastWork: [
        //             {
        //                 id: 10,
        //                 title: "شهروند",
        //                 comment: "رسیدگی به این کوچه افتضاح است رسیدگی شود",
        //                 display: false
        //             },
        //             {
        //                 id: 11,
        //                 title: "137 منطقه",
        //                 comment: "بازرسی شد و گفته شهروند صحیح است",
        //                 display: true
        //             },
        //             {
        //                 id: 12,
        //                 title: "مجری",
        //                 comment: "نظافت کامل انجام شد و تذکرات لازم و مس",
        //                 display: false
        //             },
        //             {
        //                 id: 13,
        //                 title: "رضایت مندی",
        //                 comment: "شهروند از عملیات رضایت ندارد",
        //                 display: true
        //             },
        //             {
        //                 id: 14,
        //                 title: "بازرسی",
        //                 comment: "عملیات مجری مورد تایید است",
        //                 display: true
        //             },
        //         ]
        //     },
        //     {
        //         id: 2,
        //         like: true,
        //         files: [
        //             {
        //                 id: 1,
        //                 image: "https://media.tahlilbazaar.com/d/2020/09/30/3/43418.jpg",
        //                 display: true
        //             },
        //             {
        //                 id: 2,
        //                 image: "http://media.sarpoosh.com/images/9709/97-09-c07-634.jpg",
        //                 display: true
        //             },
        //             {
        //                 id: 3,
        //                 image: "https://media.mehrnews.com/d/2016/08/10/3/2168553.jpg?ts=1486462047399",
        //                 display: true
        //             },
        //         ],
        //         lastWork: [
        //             {
        //                 id: 10,
        //                 title: "شهروند",
        //                 comment: "رسیدگی به این کوچه افتضاح است رسیدگی شود",
        //                 display: true
        //             },
        //             {
        //                 id: 11,
        //                 title: "137 منطقه",
        //                 comment: "بازرسی شد و گفته شهروند صحیح است",
        //                 display: true
        //             },
        //             {
        //                 id: 12,
        //                 title: "مجری",
        //                 comment: "نظافت کامل انجام شد و تذکرات لازم و مس",
        //                 display: true
        //             },
        //             {
        //                 id: 13,
        //                 title: "رضایت مندی",
        //                 comment: "شهروند از عملیات رضایت ندارد",
        //                 display: true
        //             },
        //             {
        //                 id: 14,
        //                 title: "بازرسی",
        //                 comment: "عملیات مجری مورد تایید است",
        //                 display: true
        //             },
        //         ]
        //     },
        // ]))

        if (firebase) {
            const channel = new firebase.notifications.Android.Channel(
                '1',
                'A',
                firebase.notifications.Android.Importance.Max
            ).setDescription('A natural description of the channel');
            firebase.notifications().android.createChannel(channel);

            // the listener returns a function you can use to unsubscribe
            this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                //  alert("yyyy")
                if (Platform.OS === 'android') {
                    const localNotification = new firebase.notifications.Notification({
                        sound: 'default',
                        show_in_foreground: true,
                    }).setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .android.setChannelId('channelId') // e.g. the id you chose above
                        .android.setSmallIcon('logo') // create this icon in Android Studio
                        .android.setLargeIcon('logo') // create this icon in Android Studio

                        //  .android.setColor('#000000') // you can set a color here
                        .android.setPriority(firebase.notifications.Android.Priority.High);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error("error_notifications", err));

                }
                else if (Platform.OS === 'ios') {

                    const localNotification = new firebase.notifications.Notification()
                        .setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .ios.setBadge(notification.ios.badge);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));
                }


                if (notification && notification.data && notification.data.typeOperation === '1') {
                    if (item.length > 0) {
                        global.list_menu_shahrdar = item;
                        this.setState({alaki: !this.state.alaki})

                    }
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }

            });


            this.notificationOpenedListener = await firebase.notifications().onNotificationOpened((notificationOpen: NotificationOpen) => {
                // Get the action triggered by the notification being opened
                const action = notificationOpen.action;
                // Get information about the notification that was opened
                const notification: Notification = notificationOpen.notification;
                let item = null
                if (notificationOpen.notification.data.item)
                    item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

                try {
                    firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)

                    switch (notificationOpen.notification.data.typeOperation) {
                        //looking for
                        case "1":
                            if (item) {
                                // if (this.props.result && this.props.result > 0) {
                                //     let idx = this.props.result.CartList.findIndex(obj => obj.RequestID === item.RequestID)
                                //     if (idx === -1) {
                                //         store.dispatch(serviceActionListFilter([]))
                                //         this.props.callserviceActionRefresh();
                                //         this.getData(1)
                                //     }
                                //
                                // }
                                //  NavigationService.navigateParams("DetailsOperatorApplyScreen", {item: item})

                                NavigationService.navigateParams("DetailsOperatorApplyScreen", {
                                    index: 0,
                                    item: item,
                                })
                            }

                            // NavigationService.navigatereset("MessagesBuy", {type: 1});
                            //NavigationService.navigateParams("MessagesBuy", {type: 2});
                            break;

                        // case "1":
                        //     // NavigationService.navigatereset("MessagesSell", {type: 2});
                        //     NavigationService.navigateParams("MessagesSell", {type: 1});
                        //     break;
                        default:

                    }

                }
                catch (e) {

                }

            });

        }


        // let myLocation = store.getState().reducerSplashGetAllData.Location;
        // myLocation ? this.sendLocation(myLocation.coords) : null;

    }

    async goDetailsOpenNotif() {
        const notificationOpen = await firebase.notifications().getInitialNotification();
        let item = null

        if (notificationOpen) {
            if (notificationOpen.notification.data.item)
                item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())
            firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)
            try {
                switch (notificationOpen.notification.data.typeOperation) {
                    //looking for
                    case "2":
                        if (item)
                            NavigationService.navigateParams("DetailsOperatorFireApplyScreen", {
                                index: 0,
                                item: item,
                            })
                        // NavigationService.navigatereset("MessagesBuy", {type: 1});
                        //     NavigationService.navigateParams("MessagesBuy", {type: 2});
                        break;

                    case "1":
                        // NavigationService.navigatereset("MessagesSell", {type: 2});
                        //NavigationService.navigateParams("MessagesSell", {type: 1});
                        break;
                    default:

                }

            }
            catch (e) {

            }
        }
    }

    componentWillUnmount() {
        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
            this.notificationOpenedListener();

        }
    }

    async getData(page) {
        this.setState({
            checkCountRequest: this.state.checkCountRequest + 1
        })
        // let {item, data} = this.props.route.params

        let after = "0000-00-00";
        //   this.props.callService(urlGalleryServiceScreen, `?type=${this.props.typee}&Condition=`, TypeGetGalleryServiceScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlGalleryServiceScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetGalleryServiceScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetGalleryServiceScreen, _GET, page, 10)
  */

        let paramss = {
            // "_operation": typeExport._NameApp,
            "_operation": typeExport._Contacts,

            "mode": checkParams ? "GetWebAlbum" : "GetAlbum",
            "lang": i18n.locale,
            "_session": store.getState().reducerSplashGetAllData.token,
            "page": page,
            // "type": data ? data.type : '',
            "listFilter": this.state.arraySelected,
            "trackingCode": this.state.trackingCode,

            //"token_fb": this.props.DataSplashScreen.token_fb,
        };
        if (store.getState().reducerSplashGetAllData.Connection) {

            this.props.callService(typeExport._baseUrlSaina, paramss, typeExport.TypeGetGalleryServiceScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApply + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApplyFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };


    render() {
        let {item, data} = this.props.route && this.props.route.params ? this.props.route.params : {}
        let City = this.props.DataSplashScreen?.City;

        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        let heightSlider = (this.state.viewportWidth > 600) ? 500 : (Platform.OS === "web" ? this.state.viewportWidth : typeExport.WIDTH) / 1.6;
        let widthSlider = this.state.viewportWidth - moderateScale(Platform.OS === "web" && !(isMobile) ? 30 : 4);

        return (
            <View style={{position: 'relative', flex: 1}}>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>

                        {
                            this.props.route && this.props.route.params && this.props.route.params.header ?

                                null
                                :
                                <HMActionBar
                                    // menu
                                    props={this.props} statusBarTransparent
                                    // text={i18n.t('ListOperatorApply.title')}
                                    //text={i18n.t('ListNews.title')}
                                    text={data ? (data.name ? data.name : (data.title ? data.title : '')) : "آلبوم خدمت"}
                                    //  text={this.state.arraySelected.length}

                                    back
                                    //  text={i18n.t('constant.Information')}

                                    headerVisibility more_menu
                                    onBackPress={() => this.props.navigation.pop()}
                                    ViewCenter={
                                        (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") ?
                                            () => {
                                                return <View style={{flexDirection: "row"}}>

                                                    <HMTextView
                                                        numberOfLines={1}
                                                        text={data ? (data.name ? data.name : (data.title ? data.title : '')) : "آلبوم خدمت"}
                                                        type="bold"
                                                        style={{
                                                            alignSelf: "center",
                                                            color: Colors.light,
                                                            fontSize: moderateScale(16),
                                                        }}
                                                    />

                                                    <HMTextView
                                                        numberOfLines={1}
                                                        text={City ? ` (${City.name}) ` : ""}
                                                        type="bold"
                                                        style={{
                                                            alignSelf: "center",
                                                            color: Colors.light,
                                                            fontSize: moderateScale(16),
                                                            marginHorizontal: moderateScale(8)
                                                        }}
                                                    />

                                                    <HMIcon
                                                        type={"AntDesign"}
                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        name={"sync"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(24)}, {
                                                            color: Colors.white
                                                        }]}
                                                        onPress={() => {
                                                            NavigationService.navigateParams("ListCityScreen")
                                                        }}
                                                    />
                                                </View>
                                            }
                                            :
                                            null
                                    }


                                />
                        }
                        {/*<TouchableOpacity
                            onPress={()=>{
                                store.dispatch(serviceActionAddSubList([{
                                    address:"aaaa",
                                    code: "_",
                                    color: "#ff0000",
                                    comment: [],
                                    createdtime: "19/8/8",
                                    image:null,
                                    video: null,
                                    latitude: '43.56564',
                                    longitude: "34.37546",
                                    status: i18n.t('constant.registrated'),
                                    title: "aaabbbb",
                                    subjectid: "111"
                                }, ...store.getState().reducerGalleryServiceScreen.results]))
                            }}
                            style={{width:'100%',height:moderateScale(40)}}
                        />*/}
                        <View style={{flex: 1}}>


                            <EmptyView empty={this.props.empty}/>


                            {/*   <FlatList
                                data={this.props.results}
                                //data={this.state.list}
                                extraData={{
                                    heightSlider: heightSlider,
                                    list: this.state.list,
                                }}
                                // legacyImplementation={true}
                                // windowsSize={100}
                                // maxToRenderPerBatch={2}
                                // NumToRender={1000}
                                renderItem={({item, index}) => {


                                    return <View
                                        style={{
                                            flex: 1,
                                            marginVertical: moderateScale(10),
                                            marginHorizontal: moderateScale(10),
                                            borderRadius: moderateScale(10),
                                            overflow: 'hidden'

                                            // alignItems: 'center'
                                        }}>

                                        <View
                                            style={{
                                                width: "100%",
                                                backgroundColor: Colors.white,
                                            }}>
                                            <View
                                                style={{
                                                    width: "100%",
                                                    // height: this.state.viewportWidth / 1.6,
                                                    height: heightSlider,
                                                    //marginTop:moderateScale(6),
                                                    // backgroundColor:"#2bee8f"
                                                }}


                                            >

                                                <HMSwiper
                                                    list={item.slider}
                                                    notLoop
                                                    notClick
                                                    notAutoPlay
                                                    renderItem={() => {
                                                        return item.slider.map((itemSwiper, indexSwiper) => {
                                                            return <DynamicContentSlide
                                                                itemSwiper={itemSwiper}
                                                                indexSwiper={indexSwiper}
                                                                onPressLike={() => {
                                                                    // if (container.state.backClickCount === 1) {
                                                                    if (backClickCount_value === 1) {
                                                                        //  alert(" " + container.state.backClickCount)
                                                                        //  container.setState({backClickCount: 0});
                                                                        backClickCount_value = 0;
                                                                        container.setLike(item, index);


                                                                    } else {
                                                                        // container.setState({backClickCount: 1}, () => {
                                                                        //
                                                                        //         setTimeout(function () {
                                                                        //             container.setState({backClickCount: 0},
                                                                        //                 () => {
                                                                        //
                                                                        //                     // onPressLike()
                                                                        //                     // alert("  " + container.state.backClickCount)
                                                                        //                 });
                                                                        //
                                                                        //         }, 300)
                                                                        //
                                                                        //     }
                                                                        // )
                                                                        backClickCount_value = 1;
                                                                        setTimeout(function () {
                                                                            backClickCount_value = 0;
                                                                        }, 200)
                                                                    }
                                                                }}

                                                                onPress={() => {
                                                                    this.setLike(item, index)

                                                                    // const formData = new FormData();
                                                                    // formData.append('lang', i18n.locale);
                                                                    // formData.append('record', item.id);
                                                                    // formData.append('recordChild', itemSwiper.id);
                                                                    // formData.append('_session', container.props.token);
                                                                    // formData.append('_operation', typeExport._Shahrdar);
                                                                    // // // formData.append('lang', params.lang);
                                                                    // formData.append('mode', "SetLikeFile");
                                                                    //
                                                                    // this.setData(() => {
                                                                    //     store.dispatch(serviceActionSetDisplayImage(!itemSwiper.display, index, indexSwiper))
                                                                    // }, formData)


                                                                }}
                                                            />

                                                        })
                                                    }}

                                                />


                                            </View>
                                            <View style={{
                                                flex: 1,
                                                flexDirection: 'row',
                                                paddingHorizontal: moderateScale(10)
                                            }}>
                                                <TouchableOpacity
                                                    disabled={checkParams}
                                                    style={{
                                                        width: moderateScale(30),
                                                        height: moderateScale(30),
                                                        alignItems: 'center', justifyContent: 'center',


                                                    }}
                                                    onPress={() => {
                                                        this.setLike(item, index)
                                                    }}

                                                >
                                                    <HMIcon
                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        name={item.like ? "md-heart" : "md-heart-outline"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(30)}, item.like ? {
                                                            color: "#ee0003"
                                                        } : {
                                                            color: "#6f6f6f"
                                                        }]}/>

                                                </TouchableOpacity>
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        if (Platform.OS === "web" && !navigator.share) {
                                                          //  alert(typeExport._Url137 + "details_gallery/" + item.id)
                                                            alert(item.sharing)

                                                        }
                                                        else
                                                            Tools.onShare({
                                                              //  link_url: typeExport._Url137 + "details_gallery/" + item.id,
                                                                link_url:item.sharing,
                                                                description: "این پست را مشاهد نمایید"
                                                            });
                                                    }}
                                                    style={{
                                                        width: moderateScale(30),
                                                        height: moderateScale(30),
                                                        alignItems: 'center', justifyContent: 'center',
                                                    }}>
                                                    <HMIcon
                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        name={"ios-share-social-outline"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(30)}, {
                                                            color: Colors.colorDarkText,
                                                        }]}/>

                                                </TouchableOpacity>
                                                <View style={{flex: 1}}/>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={item.createdtime}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(13),
                                                        marginHorizontal: moderateScale(2)

                                                    }}/>
                                            </View>
                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={`${item.count_like ? item.count_like : 0} نفر پسند شده`}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.colorDarkText,
                                                    fontSize: moderateScale(13),
                                                    marginHorizontal: moderateScale(12)

                                                }}/>

                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    flex: 1,
                                                    //  width:'100%',
                                                    //   justifyContent: "flex-end",
                                                    //  flexWrap: 'wrap',
                                                    marginHorizontal: moderateScale(12),
                                                    marginVertical: moderateScale(6),

                                                }}>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={"موضوع" + " : "}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14)

                                                    }}/>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={item.title}
                                                    type={"bold"}
                                                    style={{
                                                        //  textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(14)

                                                    }}
                                                    styleRoot={{
                                                        // flexDirection: 'column',
                                                        flex: 1,
                                                        // justifyContent: "flex-end",
                                                        flexWrap: 'wrap',
                                                        // alignItems: 'center', justifyContent: 'center'
                                                    }}
                                                />
                                            </View>
                                            <View style={{marginBottom: moderateScale(8)}}>
                                                {
                                                    item.lastWork ?
                                                        item.lastWork.map((itemWork, indexWork) => {
                                                            return <View
                                                                key={indexWork}
                                                                style={{
                                                                    flex: 1,
                                                                    flexDirection: 'row',
                                                                    marginHorizontal: moderateScale(12),
                                                                    marginVertical: moderateScale(5),
                                                                    borderWidth: moderateScale(1),
                                                                    borderRadius: moderateScale(2),
                                                                    borderColor: '#ddd',
                                                                    borderBottomWidth: 0,
                                                                    shadowColor: '#000',
                                                                    shadowOffset: {width: 0, height: moderateScale(.7)},
                                                                    shadowOpacity: 0.6,
                                                                    shadowRadius: moderateScale(2),
                                                                    elevation: moderateScale(1),

                                                                    // borderRadius: moderateScale(8),
                                                                    margin: moderateScale(8),
                                                                    padding: moderateScale(10),
                                                                    // backgroundColor:"#F2F2F2"
                                                                }}>


                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    text={itemWork.title + " : "}
                                                                    type={"bold"}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        color: Colors.blackLight,
                                                                        fontSize: moderateScale(14)

                                                                    }}/>
                                                                <View style={{
                                                                    //flexDirection: "row",
                                                                    flex: 1,
                                                                    //  width:'100%',
                                                                    //   justifyContent: "flex-end",
                                                                    flexWrap: 'wrap',

                                                                }}>
                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={itemWork.comment}
                                                                        type={"bold"}
                                                                        style={{
                                                                            //  textAlign: "center",
                                                                            color: Colors.colorDark,
                                                                            fontSize: moderateScale(14)

                                                                        }}/>
                                                                </View>
                                                            </View>
                                                        })
                                                        :
                                                        null
                                                }


                                            </View>

                                        </View>

                                    </View>
                                }}
                                keyExtractor={(item, index) => index.toString()}
                                // ItemSeparatorComponent={() => <View style={{
                                //     height: moderateScale(1),
                                //     width: "100%",
                                //     backgroundColor: "rgba(0,0,0,0.5)",
                                //     marginVertical: moderateScale(10),
                                // }}
                                // />
                                // }
                                ListEmptyComponent={() =>
                                    null}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                // maxToRenderPerBatch={10}
                                // windowSize={10}


                                // Performance settings
                                removeClippedSubviews={true} // Unmount components when outside of window
                                //initialNumToRender={2} // Reduce initial render amount
                                maxToRenderPerBatch={1} // Reduce number in each render batch
                                updateCellsBatchingPeriod={100} // Increase time between renders
                                windowSize={7} // Reduce the window size
                                // numColumns={this.state.columnCount}
                                // key={this.state.columnCount}
                            />*/}
                            <View style={{flex: 1}}>
                                {this.props.results && this.props.results.length > 0 ? (

                                    <HMRecycleView
                                        style={{flex: 1}}
                                        contentContainerStyle={{margin: 3}}
                                        onEndReached={this.handleLoadMore.bind(this)}
                                        dataProvider={this.state.dataProvider.cloneWithRows(this.props.results)}
                                        layoutProvider={this.state.layoutProvider}
                                        renderAheadOffset={0}
                                        canChangeSize={this.state.canChangeSize}
                                        forceNonDeterministicRendering={true}
                                        extendedState={{
                                            heightSlider: heightSlider,
                                            widthSlider: widthSlider,
                                            list: this.state.list,
                                        }}
                                        onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                        //   forceNonDeterministicRendering={true}


                                        //application
                                        rowRenderer={(type, item, index) => {
                                            if (Platform.OS !== "web") {
                                                item = type.item;
                                                index = type.index;
                                            }
                                            //if (index === 0)
                                            return <View
                                                style={{
                                                    width: widthSlider,
                                                    marginVertical: moderateScale(10),
                                                    // marginHorizontal: moderateScale(10),
                                                    borderRadius: moderateScale(10),
                                                    overflow: 'hidden'

                                                    // alignItems: 'center'
                                                }}>
                                                {/*<View style={{*/}
                                                {/*width: this.state.viewportWidth - moderateScale(10),*/}
                                                {/*height: moderateScale(1),*/}
                                                {/*backgroundColor: "transparent"*/}
                                                {/*}}/>*/}
                                                <View
                                                    style={{
                                                        width: "100%",
                                                        backgroundColor: Colors.white,
                                                    }}>
                                                    <View
                                                        style={{
                                                            width: "100%",
                                                            // height: this.state.viewportWidth / 1.6,
                                                            height: heightSlider,
                                                            //marginTop:moderateScale(6),
                                                            // backgroundColor:"#2bee8f"
                                                        }}


                                                    >
                                                        {
                                                            item.slider && item.slider.length > 0 ?
                                                                <HMSwiper
                                                                    list={item.slider}
                                                                    item={item}
                                                                    notLoop
                                                                    notClick
                                                                    notAutoPlay
                                                                    renderItem={() => {
                                                                        return item.slider.map((itemSwiper, indexSwiper) => {
                                                                            return <DynamicContentSlide
                                                                                itemSwiper={itemSwiper}
                                                                                indexSwiper={indexSwiper}
                                                                                onPressLike={() => {
                                                                                    // if (container.state.backClickCount === 1) {
                                                                                    if (backClickCount_value === 1) {
                                                                                        //  alert(" " + container.state.backClickCount)
                                                                                        //  container.setState({backClickCount: 0});
                                                                                        backClickCount_value = 0;
                                                                                        container.setLike(item, index);


                                                                                    } else {
                                                                                        // container.setState({backClickCount: 1}, () => {
                                                                                        //
                                                                                        //         setTimeout(function () {
                                                                                        //             container.setState({backClickCount: 0},
                                                                                        //                 () => {
                                                                                        //
                                                                                        //                     // onPressLike()
                                                                                        //                     // alert("  " + container.state.backClickCount)
                                                                                        //                 });
                                                                                        //
                                                                                        //         }, 300)
                                                                                        //
                                                                                        //     }
                                                                                        // )
                                                                                        backClickCount_value = 1;
                                                                                        setTimeout(function () {
                                                                                            backClickCount_value = 0;
                                                                                        }, 200)
                                                                                    }
                                                                                }}

                                                                                onPress={() => {
                                                                                    this.setLike(item, index)

                                                                                    // const formData = new FormData();
                                                                                    // formData.append('lang', i18n.locale);
                                                                                    // formData.append('record', item.id);
                                                                                    // formData.append('recordChild', itemSwiper.id);
                                                                                    // formData.append('_session', container.props.token);
                                                                                    // formData.append('_operation', typeExport._Shahrdar);
                                                                                    // // // formData.append('lang', params.lang);
                                                                                    // formData.append('mode', "SetLikeFile");
                                                                                    //
                                                                                    // this.setData(() => {
                                                                                    //     store.dispatch(serviceActionSetDisplayImage(!itemSwiper.display, index, indexSwiper))
                                                                                    // }, formData)


                                                                                }}
                                                                            />

                                                                        })
                                                                    }}

                                                                />
                                                                :
                                                                <View
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        backgroundColor: Colors.gray,
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    <HMIcon
                                                                        type={"FontAwesome"}
                                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                        name={"picture-o"}
                                                                        //resizeMode="stretch"
                                                                        style={[{fontSize: moderateScale(48)}, {
                                                                            color: Colors.white
                                                                        }]}/>
                                                                </View>

                                                        }

                                                    </View>
                                                    <View style={{
                                                        flex: 1,
                                                        flexDirection: 'row',
                                                        paddingHorizontal: moderateScale(10)
                                                    }}>
                                                        <TouchableOpacity
                                                            disabled={checkParams || ((this.props.DataSplashScreen.TypeLogin) > 1)}
                                                            style={{
                                                                width: moderateScale(30),
                                                                height: moderateScale(30),
                                                                alignItems: 'center', justifyContent: 'center',


                                                            }}
                                                            onPress={() => {

                                                                this.setLike(item, index)
                                                            }}

                                                        >
                                                            <HMIcon
                                                                // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                name={item.like ? "md-heart" : "md-heart-outline"}
                                                                //resizeMode="stretch"
                                                                style={[{fontSize: moderateScale(30)}, item.like ? {
                                                                    color: "#ee0003"
                                                                } : {
                                                                    color: "#6f6f6f"
                                                                }]}/>

                                                        </TouchableOpacity>
                                                        <TouchableOpacity
                                                            onPress={() => {
                                                                if (Platform.OS === "web" && !navigator.share) {
                                                                    //  alert(typeExport._Url137 + "details_gallery/" + item.id)
                                                                    // alert(item.sharing)
                                                                    Tools.copyClipboardWeb(item.sharing);

                                                                    // HMAlert(
                                                                    //     i18n.t('constant.message'),
                                                                    //     item.sharing + " \n" + "لینک کپی شد",
                                                                    //     [
                                                                    //         {
                                                                    //             text: i18n.t('constant.ok'),
                                                                    //             onPress: () => {
                                                                    //
                                                                    //             }
                                                                    //
                                                                    //
                                                                    //         },
                                                                    //
                                                                    //     ],
                                                                    //     {cancelable: true}
                                                                    // )

                                                                }
                                                                else
                                                                    Tools.onShare({
                                                                        //  link_url: typeExport._Url137 + "details_gallery/" + item.id,
                                                                        link_url: item.sharing,
                                                                        description: "این پست را مشاهد نمایید"
                                                                    });
                                                            }}
                                                            style={{
                                                                width: moderateScale(30),
                                                                height: moderateScale(30),
                                                                alignItems: 'center', justifyContent: 'center',
                                                            }}>
                                                            <HMIcon
                                                                // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                name={"ios-share-social-outline"}
                                                                //resizeMode="stretch"
                                                                style={[{fontSize: moderateScale(30)}, {
                                                                    color: Colors.colorDarkText,
                                                                }]}/>

                                                        </TouchableOpacity>
                                                        <View style={{flex: 1}}/>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.createdtime}
                                                            type={"bold"}
                                                            style={{
                                                                textAlign: "center",
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(13),
                                                                marginHorizontal: moderateScale(2)

                                                            }}/>
                                                    </View>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={`${item.count_like ? item.count_like : 0} نفر پسند شده`}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(13),
                                                            marginHorizontal: moderateScale(12)

                                                        }}/>

                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            flex: 1,
                                                            //  width:'100%',
                                                            //   justifyContent: "flex-end",
                                                            //  flexWrap: 'wrap',
                                                            marginHorizontal: moderateScale(12),
                                                            marginVertical: moderateScale(6),

                                                        }}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={"موضوع" + " : "}
                                                            type={"bold"}
                                                            style={{
                                                                textAlign: "center",
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(14)

                                                            }}/>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.title}
                                                            type={"bold"}
                                                            style={{
                                                                //  textAlign: "center",
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(14)

                                                            }}
                                                            styleRoot={{
                                                                // flexDirection: 'column',
                                                                flex: 1,
                                                                // justifyContent: "flex-end",
                                                                flexWrap: 'wrap',
                                                                // alignItems: 'center', justifyContent: 'center'
                                                            }}
                                                        />
                                                    </View>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            flex: 1,
                                                            //  width:'100%',
                                                            //   justifyContent: "flex-end",
                                                            flexWrap: 'wrap',
                                                            marginHorizontal: moderateScale(12),
                                                            marginVertical: moderateScale(6),

                                                        }}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={"آدرس" + " : "}
                                                            type={"bold"}
                                                            style={{
                                                                textAlign: "center",
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(14)

                                                            }}/>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.address}
                                                            type={"bold"}
                                                            style={{
                                                                //  textAlign: "center",
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(14)

                                                            }}
                                                            styleRoot={{
                                                                flexDirection: 'row',
                                                                flex: 1,
                                                                // justifyContent: "flex-end",
                                                                flexWrap: 'wrap',
                                                                //    alignItems: 'center', justifyContent: 'center'
                                                            }}
                                                        />
                                                    </View>
                                                    <View style={{marginBottom: moderateScale(8)}}>
                                                        {
                                                            item.lastWork ?
                                                                item.lastWork.map((itemWork, indexWork) => {
                                                                    return <View
                                                                        key={indexWork}
                                                                        style={{
                                                                            flexDirection: Platform.OS === "web" && this.state.viewportWidth > 800 ? "row" : "column",
                                                                            flex: 1,
                                                                            //  width:'100%',
                                                                            //   justifyContent: "flex-end",
                                                                            flexWrap: 'wrap',
                                                                            marginHorizontal: moderateScale(12),
                                                                            marginVertical: moderateScale(5),
                                                                            borderWidth: moderateScale(1),
                                                                            borderRadius: moderateScale(2),
                                                                            borderColor: '#ddd',
                                                                            borderBottomWidth: 0,
                                                                            shadowColor: '#000',
                                                                            shadowOffset: {
                                                                                width: 0,
                                                                                height: moderateScale(.7)
                                                                            },
                                                                            shadowOpacity: 0.6,
                                                                            shadowRadius: moderateScale(2),
                                                                            elevation: moderateScale(1),

                                                                            // borderRadius: moderateScale(8),
                                                                            margin: moderateScale(8),
                                                                            padding: moderateScale(10),
                                                                            // backgroundColor:"#F2F2F2"
                                                                        }}>

                                                                        <HMTextView
                                                                            //                                                    flexDirection: Platform.OS==="web"&& this.state.viewportWidth>800?"row":"column",
                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                            text={itemWork.title + " : "}
                                                                            type={"bold"}
                                                                            style={{
                                                                                textAlign: "center",
                                                                                color: Colors.blackLight,
                                                                                fontSize: moderateScale(14)

                                                                            }}/>
                                                                        <HMTextView
                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                            text={itemWork.comment}
                                                                            type={"bold"}
                                                                            style={{
                                                                                //  textAlign: "center",
                                                                                color: Colors.colorDark,
                                                                                fontSize: moderateScale(14)

                                                                            }}

                                                                            styleRoot={{
                                                                                //  flexDirection: "row",
                                                                                flex: 1,
                                                                                //  width:'100%',
                                                                                //   justifyContent: "flex-end",
                                                                                flexWrap: 'wrap',

                                                                            }}
                                                                        />
                                                                    </View>
                                                                })
                                                                :
                                                                null
                                                        }


                                                    </View>

                                                </View>

                                            </View>
                                        }}
                                        renderFooter={this.renderFooter.bind(this)}
                                        columnCount={this.state.columnCount}
                                        initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                        refreshing={this.props.showRefresh}
                                        keyExtractor={(item, index) => index.toString()}
                                        data={this.props.results}
                                    />
                                    /* <RecyclerListView
                                         style={{flex: 1}}
                                         contentContainerStyle={{margin: 3}}
                                         onEndReached={this.handleLoadMore.bind(this)}
                                         dataProvider={this.state.dataProvider.cloneWithRows(this.props.results)}
                                         layoutProvider={this.state.layoutProvider}
                                         renderAheadOffset={0}
                                         canChangeSize={this.state.canChangeSize}
                                         forceNonDeterministicRendering={true}
                                         extendedState={{
                                             heightSlider: heightSlider,
                                             widthSlider: widthSlider,

                                             list: this.state.list,
                                         }}
                                         onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                         //   forceNonDeterministicRendering={true}
                                         rowRenderer={(type, item, index) => {

                                             //if (index === 0)
                                             return <View
                                                 style={{
                                                     width: widthSlider,
                                                     marginVertical: moderateScale(10),
                                                     marginHorizontal: moderateScale(10),
                                                     borderRadius: moderateScale(10),
                                                     overflow: 'hidden'

                                                     // alignItems: 'center'
                                                 }}>
                                                 {/!*<View style={{*!/}
                                                     {/!*width: this.state.viewportWidth - moderateScale(10),*!/}
                                                     {/!*height: moderateScale(1),*!/}
                                                     {/!*backgroundColor: "transparent"*!/}
                                                 {/!*}}/>*!/}
                                                 <View
                                                     style={{
                                                         width: "100%",
                                                         backgroundColor: Colors.white,
                                                     }}>
                                                     <View
                                                         style={{
                                                             width: "100%",
                                                             // height: this.state.viewportWidth / 1.6,
                                                             height: heightSlider,
                                                             //marginTop:moderateScale(6),
                                                             // backgroundColor:"#2bee8f"
                                                         }}


                                                     >
                                                         {
                                                             item.slider && item.slider.length > 0 ?
                                                         <HMSwiper
                                                             list={item.slider}
                                                             item={item}
                                                             notLoop
                                                             notClick
                                                             notAutoPlay
                                                             renderItem={() => {
                                                                 return item.slider.map((itemSwiper, indexSwiper) => {
                                                                     return <DynamicContentSlide
                                                                         itemSwiper={itemSwiper}
                                                                         indexSwiper={indexSwiper}
                                                                         onPressLike={() => {
                                                                             // if (container.state.backClickCount === 1) {
                                                                             if (backClickCount_value === 1) {
                                                                                 //  alert(" " + container.state.backClickCount)
                                                                                 //  container.setState({backClickCount: 0});
                                                                                 backClickCount_value = 0;
                                                                                 container.setLike(item, index);


                                                                             } else {
                                                                                 // container.setState({backClickCount: 1}, () => {
                                                                                 //
                                                                                 //         setTimeout(function () {
                                                                                 //             container.setState({backClickCount: 0},
                                                                                 //                 () => {
                                                                                 //
                                                                                 //                     // onPressLike()
                                                                                 //                     // alert("  " + container.state.backClickCount)
                                                                                 //                 });
                                                                                 //
                                                                                 //         }, 300)
                                                                                 //
                                                                                 //     }
                                                                                 // )
                                                                                 backClickCount_value = 1;
                                                                                 setTimeout(function () {
                                                                                     backClickCount_value = 0;
                                                                                 }, 200)
                                                                             }
                                                                         }}

                                                                         onPress={() => {
                                                                             this.setLike(item, index)

                                                                             // const formData = new FormData();
                                                                             // formData.append('lang', i18n.locale);
                                                                             // formData.append('record', item.id);
                                                                             // formData.append('recordChild', itemSwiper.id);
                                                                             // formData.append('_session', container.props.token);
                                                                             // formData.append('_operation', typeExport._Shahrdar);
                                                                             // // // formData.append('lang', params.lang);
                                                                             // formData.append('mode', "SetLikeFile");
                                                                             //
                                                                             // this.setData(() => {
                                                                             //     store.dispatch(serviceActionSetDisplayImage(!itemSwiper.display, index, indexSwiper))
                                                                             // }, formData)


                                                                         }}
                                                                     />

                                                                 })
                                                             }}

                                                         />
                                                                 :
                                                                 <View
                                                                     style={{
                                                                         width: '100%',
                                                                         height: '100%',
                                                                         backgroundColor: Colors.gray,
                                                                         alignItems:'center',
                                                                         justifyContent:'center',
                                                                     }}
                                                                 >
                                                                     <HMIcon
                                                                         type={"FontAwesome"}
                                                                         // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                         name={"picture-o"}
                                                                         //resizeMode="stretch"
                                                                         style={[{fontSize: moderateScale(48)},{
                                                                             color: Colors.white
                                                                         }]}/>
                                                                 </View>

                                                         }

                                                     </View>
                                                     <View style={{
                                                         flex: 1,
                                                         flexDirection: 'row',
                                                         paddingHorizontal: moderateScale(10)
                                                     }}>
                                                         <TouchableOpacity
                                                             disabled={checkParams}
                                                             style={{
                                                                 width: moderateScale(30),
                                                                 height: moderateScale(30),
                                                                 alignItems: 'center', justifyContent: 'center',


                                                             }}
                                                             onPress={() => {
                                                                 this.setLike(item, index)
                                                             }}

                                                         >
                                                             <HMIcon
                                                                 // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                 name={item.like ? "md-heart" : "md-heart-outline"}
                                                                 //resizeMode="stretch"
                                                                 style={[{fontSize: moderateScale(30)}, item.like ? {
                                                                     color: "#ee0003"
                                                                 } : {
                                                                     color: "#6f6f6f"
                                                                 }]}/>

                                                         </TouchableOpacity>
                                                         <TouchableOpacity
                                                             onPress={() => {
                                                                 if (Platform.OS === "web" && !navigator.share) {
                                                                     //  alert(typeExport._Url137 + "details_gallery/" + item.id)
                                                                     alert(item.sharing)

                                                                 }
                                                                 else
                                                                     Tools.onShare({
                                                                         //  link_url: typeExport._Url137 + "details_gallery/" + item.id,
                                                                         link_url:item.sharing,
                                                                         description: "این پست را مشاهد نمایید"
                                                                     });
                                                             }}
                                                             style={{
                                                                 width: moderateScale(30),
                                                                 height: moderateScale(30),
                                                                 alignItems: 'center', justifyContent: 'center',
                                                             }}>
                                                             <HMIcon
                                                                 // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                 name={"ios-share-social-outline"}
                                                                 //resizeMode="stretch"
                                                                 style={[{fontSize: moderateScale(30)}, {
                                                                     color: Colors.colorDarkText,
                                                                 }]}/>

                                                         </TouchableOpacity>
                                                         <View style={{flex: 1}}/>
                                                         <HMTextView
                                                             //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                             text={item.createdtime}
                                                             type={"bold"}
                                                             style={{
                                                                 textAlign: "center",
                                                                 color: Colors.colorDark,
                                                                 fontSize: moderateScale(13),
                                                                 marginHorizontal: moderateScale(2)

                                                             }}/>
                                                     </View>
                                                     <HMTextView
                                                         //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                         text={`${item.count_like ? item.count_like : 0} نفر پسند شده`}
                                                         type={"bold"}
                                                         style={{
                                                             textAlign: "center",
                                                             color: Colors.colorDarkText,
                                                             fontSize: moderateScale(13),
                                                             marginHorizontal: moderateScale(12)

                                                         }}/>

                                                     <View
                                                         style={{
                                                             flexDirection: "row",
                                                             flex: 1,
                                                             //  width:'100%',
                                                             //   justifyContent: "flex-end",
                                                             //  flexWrap: 'wrap',
                                                             marginHorizontal: moderateScale(12),
                                                             marginVertical: moderateScale(6),

                                                         }}>
                                                         <HMTextView
                                                             //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                             text={"موضوع" + " : "}
                                                             type={"bold"}
                                                             style={{
                                                                 textAlign: "center",
                                                                 color: Colors.blackLight,
                                                                 fontSize: moderateScale(14)

                                                             }}/>
                                                         <HMTextView
                                                             //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                             text={item.title}
                                                             type={"bold"}
                                                             style={{
                                                                 //  textAlign: "center",
                                                                 color: Colors.colorDark,
                                                                 fontSize: moderateScale(14)

                                                             }}
                                                             styleRoot={{
                                                                 // flexDirection: 'column',
                                                                 flex: 1,
                                                                 // justifyContent: "flex-end",
                                                                 flexWrap: 'wrap',
                                                                 // alignItems: 'center', justifyContent: 'center'
                                                             }}
                                                         />
                                                     </View>
                                                     <View style={{marginBottom: moderateScale(8)}}>
                                                         {
                                                             item.lastWork ?
                                                                 item.lastWork.map((itemWork, indexWork) => {
                                                                     return <View
                                                                         key={indexWork}
                                                                         style={{
                                                                             flexDirection: Platform.OS === "web" && this.state.viewportWidth > 800 ? "row" : "column",
                                                                             flex: 1,
                                                                             //  width:'100%',
                                                                             //   justifyContent: "flex-end",
                                                                             flexWrap: 'wrap',
                                                                             marginHorizontal: moderateScale(12),
                                                                             marginVertical: moderateScale(5),
                                                                             borderWidth: moderateScale(1),
                                                                             borderRadius: moderateScale(2),
                                                                             borderColor: '#ddd',
                                                                             borderBottomWidth: 0,
                                                                             shadowColor: '#000',
                                                                             shadowOffset: {width: 0, height: moderateScale(.7)},
                                                                             shadowOpacity: 0.6,
                                                                             shadowRadius: moderateScale(2),
                                                                             elevation: moderateScale(1),

                                                                             // borderRadius: moderateScale(8),
                                                                             margin: moderateScale(8),
                                                                             padding: moderateScale(10),
                                                                             // backgroundColor:"#F2F2F2"
                                                                         }}>

                                                                         <HMTextView
                                                                             //                                                    flexDirection: Platform.OS==="web"&& this.state.viewportWidth>800?"row":"column",
                                                                             //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                             text={itemWork.title + " : "}
                                                                             type={"bold"}
                                                                             style={{
                                                                                 textAlign: "center",
                                                                                 color: Colors.blackLight,
                                                                                 fontSize: moderateScale(14)

                                                                             }}/>
                                                                         <HMTextView
                                                                             //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                             text={itemWork.comment}
                                                                             type={"bold"}
                                                                             style={{
                                                                                 //  textAlign: "center",
                                                                                 color: Colors.colorDark,
                                                                                 fontSize: moderateScale(14)

                                                                             }}

                                                                             styleRoot={{
                                                                                 //  flexDirection: "row",
                                                                                 flex: 1,
                                                                                 //  width:'100%',
                                                                                 //   justifyContent: "flex-end",
                                                                                 flexWrap: 'wrap',

                                                                             }}
                                                                         />
                                                                     </View>
                                                                 })
                                                                 :
                                                                 null
                                                         }


                                                     </View>

                                                 </View>

                                             </View>
                                         }}
                                         renderFooter={this.renderFooter.bind(this)}
                                     />*/
                                ) : null}
                            </View>

                            {/*    {this.props.results && this.props.results.length > 0 ? (
                                <RecyclerListView
                                    style={{flex: 1}}
                                    contentContainerStyle={{margin: 3}}
                                    onEndReached={this.handleLoadMore.bind(this)}
                                    dataProvider={this.state.dataProvider.cloneWithRows(this.props.results)}
                                    layoutProvider={this.state.layoutProvider}
                                    renderAheadOffset={0}
                                    canChangeSize={true}
                                    extendedState={{
                                        heightSlider: heightSlider,
                                        list: this.state.list,
                                    }}
                                    onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                    //   forceNonDeterministicRendering={true}
                                    rowRenderer={(type, item, index) => {

                                        //if (index === 0)
                                        return <View
                                            key={index}
                                            style={{
                                                flex: 1,
                                                marginVertical: moderateScale(10),
                                                marginHorizontal: moderateScale(10),
                                                borderRadius: moderateScale(10),
                                                overflow: 'hidden'

                                                // alignItems: 'center'
                                            }}>

                                            <View
                                                style={{
                                                    width: "100%",
                                                    backgroundColor: Colors.white,
                                                }}>
                                                <View
                                                    style={{
                                                        width: "100%",
                                                        // height: this.state.viewportWidth / 1.6,
                                                        height: heightSlider,
                                                        //marginTop:moderateScale(6),
                                                        // backgroundColor:"#2bee8f"
                                                    }}


                                                >

                                                    <HMSwiper
                                                        list={item.slider}
                                                        notLoop
                                                        notClick
                                                        notAutoPlay
                                                        renderItem={() => {
                                                            return item.slider.map((itemSwiper, indexSwiper) => {
                                                                return <DynamicContentSlide
                                                                    itemSwiper={itemSwiper}
                                                                    indexSwiper={indexSwiper}
                                                                    onPressLike={() => {
                                                                        if (container.state.backClickCount === 1) {
                                                                            //  alert(" " + container.state.backClickCount)
                                                                            container.setState({backClickCount: 0});
                                                                            container.setLike(item, index);


                                                                        } else {
                                                                            container.setState({backClickCount: 1}, () => {

                                                                                    setTimeout(function () {
                                                                                        container.setState({backClickCount: 0},
                                                                                            () => {

                                                                                                // onPressLike()
                                                                                                // alert("  " + container.state.backClickCount)
                                                                                            });

                                                                                    }, 300)

                                                                                }
                                                                            )
                                                                        }
                                                                    }}

                                                                    onPress={() => {

                                                                        const formData = new FormData();
                                                                        formData.append('lang', i18n.locale);
                                                                        formData.append('record', item.id);
                                                                        formData.append('recordChild', itemSwiper.id);
                                                                        formData.append('_session', container.props.token);
                                                                        formData.append('_operation', typeExport._Shahrdar);
                                                                        // // formData.append('lang', params.lang);
                                                                        formData.append('mode', "SetLikeFile");

                                                                        this.setData(() => {
                                                                            store.dispatch(serviceActionSetDisplayImage(!itemSwiper.display, index, indexSwiper))
                                                                        }, formData)


                                                                    }}
                                                                />

                                                            })
                                                        }}

                                                    />


                                                </View>
                                                <View style={{
                                                    flex: 1,
                                                    flexDirection: 'row',
                                                    paddingHorizontal: moderateScale(10)
                                                }}>
                                                    <TouchableOpacity
                                                        style={{
                                                            width: moderateScale(30),
                                                            height: moderateScale(30),
                                                            alignItems: 'center', justifyContent: 'center',


                                                        }}
                                                        onPress={() => {
                                                            this.setLike(item, index)
                                                        }}

                                                    >
                                                        <HMIcon
                                                            // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                            name={item.like ? "md-heart" : "md-heart-outline"}
                                                            //resizeMode="stretch"
                                                            style={[{fontSize: moderateScale(30)}, item.like ? {
                                                                color: "#ee0003"
                                                            } : {
                                                                color: "#6f6f6f"
                                                            }]}/>

                                                    </TouchableOpacity>

                                                    <View style={{flex: 1}}/>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={item.createdtime}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(13),
                                                            marginHorizontal: moderateScale(2)

                                                        }}/>
                                                </View>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={`${item.count_like ? item.count_like : 0} نفر پسند شده`}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.colorDarkText,
                                                        fontSize: moderateScale(13),
                                                        marginHorizontal: moderateScale(12)

                                                    }}/>

                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        flex: 1,
                                                        //  width:'100%',
                                                        //   justifyContent: "flex-end",
                                                        //  flexWrap: 'wrap',
                                                        marginHorizontal: moderateScale(12),
                                                        marginVertical: moderateScale(6),

                                                    }}>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={"موضوع" + " : "}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(14)

                                                        }}/>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={item.title}
                                                        type={"bold"}
                                                        style={{
                                                            //  textAlign: "center",
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(14)

                                                        }}
                                                        styleRoot={{
                                                            flexDirection: 'column',
                                                            flex: 1,
                                                            // justifyContent: "flex-end",
                                                            flexWrap: 'wrap',
                                                            // alignItems: 'center', justifyContent: 'center'
                                                        }}
                                                    />
                                                </View>
                                                <View style={{marginBottom: moderateScale(8)}}>
                                                    {
                                                        item.lastWork ?
                                                            item.lastWork.map((itemWork, indexWork) => {
                                                                return <View
                                                                    style={{
                                                                        flex: 1,
                                                                        flexDirection: 'row',
                                                                        marginHorizontal: moderateScale(12),
                                                                        marginVertical: moderateScale(5),
                                                                        borderWidth: moderateScale(1),
                                                                        borderRadius: moderateScale(2),
                                                                        borderColor: '#ddd',
                                                                        borderBottomWidth: 0,
                                                                        shadowColor: '#000',
                                                                        shadowOffset: {
                                                                            width: 0,
                                                                            height: moderateScale(.7)
                                                                        },
                                                                        shadowOpacity: 0.6,
                                                                        shadowRadius: moderateScale(2),
                                                                        elevation: moderateScale(1),

                                                                        // borderRadius: moderateScale(8),
                                                                        margin: moderateScale(8),
                                                                        padding: moderateScale(10),
                                                                        // backgroundColor:"#F2F2F2"
                                                                    }}>


                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={itemWork.title + " : "}
                                                                        type={"bold"}
                                                                        style={{
                                                                            textAlign: "center",
                                                                            color: Colors.blackLight,
                                                                            fontSize: moderateScale(14)

                                                                        }}/>
                                                                    <View style={{
                                                                        //flexDirection: "row",
                                                                        flex: 1,
                                                                        //  width:'100%',
                                                                        //   justifyContent: "flex-end",
                                                                        flexWrap: 'wrap',

                                                                    }}>
                                                                        <HMTextView
                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                            text={itemWork.comment}
                                                                            type={"bold"}
                                                                            style={{
                                                                                //  textAlign: "center",
                                                                                color: Colors.colorDark,
                                                                                fontSize: moderateScale(14)

                                                                            }}/>
                                                                    </View>
                                                                </View>
                                                            })
                                                            :
                                                            null
                                                    }


                                                </View>

                                            </View>

                                        </View>
                                    }}
                                    //renderFooter={this.renderFooter}
                                />
                            ) : null}*/}
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }
                            {
                                this.state.isLoading || (this.props.results && this.props.results.length === 0) ?
                                    <DialogLoadingCustomize
                                    />
                                    :
                                    null
                            }
                            <HMModalSearch
                                visibleModal={this.state.visibleModal === 'Modal'}
                                hiddenModal={() => this.hiddenModal()}
                                textInput={this.state["text" + this.state.indexFilter]}
                                SearchFilterFunction={text => this.SearchFilterFunction("array", "text", text, childFilter)}
                                //textInput={this.state.mobile}
                                dataSource={this.state["dataSource" + this.state.indexFilter]}
                                // onChange={() => this.onChangeCondition(index, item)}
                                onChangeItem={this.onChange}
                            />

                            <HMModal
                                // style={{backgroundColor: Colors.transparent}}
                                // position={"center"}
                                // ref={"modal"}
                                // backdropPressToClose={true}
                                // coverScreen={true}
                                // swipeToClose={true}
                                // backButtonClose={true}
                                // isOpen={this.state.showModal}
                                // onClosed={() => this.setState({showModal: false})}

                                isVisible={this.state.showModal}
                                //visible={this.state.visibleModal}
                                backdropColor={Colors.gray}
                                backdropOpacity={0.8}
                                animationIn="zoomInDown"
                                animationOut="zoomOutUp"
                                animationInTiming={600}
                                animationOutTiming={600}
                                backdropTransitionInTiming={600}
                                backdropTransitionOutTiming={600}
                                //style={{height: '60%'}}
                                onBackdropPress={() =>
                                    this.setState({showModal: false, typeModal: ""})
                                }
                                onBackButtonPress={() =>
                                    this.setState({showModal: false, typeModal: ""})
                                }

                                animationType="slide"
                                // transparent={true}
                            >

                                {

                                    this.state.showModal === "selectImage" ?
                                        <TouchableOpacity
                                            activeOpacity={1}
                                            style={{
                                                width: "100%",
                                                backgroundColor: Colors.white,
                                                padding: moderateScale(16),
                                                position: 'absolute',
                                                bottom: 0,
                                            }}>
                                            <View style={{
                                                width: '100%',
                                                flexDirection: 'row',
                                                marginBottom: moderateScale(6)
                                            }}>
                                                {
                                                    Platform.OS !== "web" ?
                                                        <TouchableOpacity
                                                            onPress={() => {
                                                                if (Platform.OS !== "web")
                                                                    ImagePicker.openCamera(typeExport.optional).then(image => {
                                                                        this.uploadFile(image);
                                                                    });

                                                            }}
                                                            style={{
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                backgroundColor: '#A131C9',
                                                                width: moderateScale(48),
                                                                height: moderateScale(48),
                                                                borderRadius: moderateScale(24),
                                                                margin: moderateScale(5),
                                                                padding: moderateScale(8),
                                                                //  borderRadius: moderateScale(4),
                                                            }}>


                                                            <HMIcon type={"FontAwesome"} name={"camera"} style={{
                                                                width: moderateScale(22),
                                                                height: moderateScale(22),
                                                                //  borderRadius:moderateScale(20),
                                                                textAlign: 'center',
                                                                //alignSelf: 'flex-end',
                                                                color: Colors.white,
                                                                //width: moderateScale(32),
                                                                // height: moderateScale(32),
                                                                fontSize: moderateScale(21)
                                                            }}/>

                                                        </TouchableOpacity>
                                                        :
                                                        null
                                                }


                                                <View
                                                    style={{
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: moderateScale(48),
                                                        height: moderateScale(48),

                                                        //  borderRadius: moderateScale(4),
                                                    }}
                                                >
                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            if (Platform.OS !== "web")
                                                                ImagePicker.openPicker({
                                                                    width: 1000,
                                                                    height: 1000,
                                                                    // crop: true,

                                                                    cropping: true
                                                                }).then(image => {
                                                                    // this.state.listImage.push(image)
                                                                    this.uploadFile(image);


                                                                });


                                                        }}
                                                        style={{
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            backgroundColor: '#3AABDC',
                                                            padding: moderateScale(8),
                                                            margin: moderateScale(5),
                                                            width: moderateScale(48),
                                                            height: moderateScale(48),
                                                            borderRadius: moderateScale(24),
                                                        }}>

                                                        <HMIcon type={"FontAwesome"} name={"image"} style={{
                                                            width: moderateScale(22),
                                                            height: moderateScale(22),
                                                            //  borderRadius:moderateScale(20),
                                                            textAlign: 'center',
                                                            //alignSelf: 'flex-end',
                                                            color: Colors.white,
                                                            //width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            fontSize: moderateScale(21)
                                                        }}/>


                                                    </TouchableOpacity>
                                                    {
                                                        Platform.OS !== "web" ?
                                                            null
                                                            :
                                                            <label
                                                                onChange={this.fileSelect}

                                                                // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    bottom: 0,
                                                                    left: 0,
                                                                    right: 0,
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    opacity: .009
                                                                }}>
                                                                <input type="file" accept="image/*"/>

                                                            </label>
                                                    }
                                                </View>
                                            </View>
                                        </TouchableOpacity>
                                        :
                                        (
                                            this.state.showModal ?
                                                <TouchableOpacity
                                                    activeOpacity={1}
                                                    style={{
                                                        width: "96%",
                                                        backgroundColor: Colors.white,
                                                        padding: moderateScale(16)
                                                    }}>


                                                    <View style={{width: '100%'}}>
                                                        <HMTextView
                                                            type={"bold"}
                                                            noFont={false}
                                                            text={"متن مورد نظر را ویرایش نمایید"}
                                                            numberOfLines={1}
                                                            style={{
                                                                fontSize: moderateScale(15),
                                                                textAlign: 'right',
                                                                color: Colors.blackLight
                                                            }}/>
                                                        <View
                                                            style={{

                                                                paddingVertical: moderateScale(10),
                                                                marginHorizontal: moderateScale(6)
                                                            }}
                                                        >
                                                            <HMTextInput
                                                                value={this.state.comment}
                                                                number
                                                                onChangeText={text => {
                                                                    this.setState({comment: text})
                                                                }}

                                                                _height={moderateScale(100)}
                                                                //   keyboardType="numeric"
                                                                //  placeholder={i18n.t('constant.PlaceholderDesc')}
                                                                style={{
                                                                    // height:moderateScale(100),
                                                                    fontSize: moderateScale(14)
                                                                }} underlineColorAndroid="transparent"
                                                                styleInput={{height: moderateScale(80)}}

                                                                // textCenter={'center'}
                                                            />


                                                        </View>
                                                        <TouchableOpacity
                                                            style={{
                                                                backgroundColor: Colors.colorPrimary,
                                                                width: moderateScale(100),
                                                                height: moderateScale(40),
                                                                alignSelf: 'center',
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                marginTop: moderateScale(8),
                                                                borderRadius: moderateScale(6)
                                                                // borderRadius:moderateScale(2)
                                                            }}
                                                            onPress={() => {
                                                                let {index, indexWork, item, itemWork} = this.state
                                                                // this.getData()

                                                                const formData = new FormData();
                                                                formData.append('lang', i18n.locale);
                                                                //  formData.append('record', item.id);
                                                                let id = ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) ? item.tracking_code : item.id;
                                                                formData.append('record', id);
                                                                formData.append('recordChild', itemWork.id);
                                                                formData.append('_session', container.props.token);
                                                                formData.append('_operation', typeExport._Shahrdar);
                                                                // // formData.append('lang', params.lang);
                                                                formData.append('mode', "EditAlbumComment");
                                                                formData.append('comment', this.state.comment);

                                                                this.setData(() => {
                                                                    store.dispatch(serviceActionSetComment(this.state.comment, index, indexWork))

                                                                    this.setState({showModal: false}
                                                                        ,
                                                                        () => {

                                                                        }
                                                                    )
                                                                }, formData)


                                                                // const some_array = [...this.state.list]
                                                                //
                                                                // some_array[index].lastWork[indexWork].comment = this.state.comment
                                                                //
                                                                // this.setState({list: some_array, showModal: false}
                                                                //     ,
                                                                //     () => {

                                                                //     }
                                                                // )
                                                            }}
                                                        >
                                                            <View style={{
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}>
                                                                <HMTextView type={"bold"}
                                                                    //   text={i18n.t('constant.signIn')}
                                                                            text={i18n.t('constant.Edit')}

                                                                            style={{
                                                                                color: "white",
                                                                                fontSize: moderateScale(13),
                                                                                //marginEnd: moderateScale(10)
                                                                            }}/>

                                                            </View>
                                                        </TouchableOpacity>
                                                    </View>


                                                </TouchableOpacity>
                                                :
                                                null
                                        )

                                }

                            </HMModal>
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderItem = ({item, index}) => {
        return <AdapterListOperatorApply item={item} item_parent={this.props.route.params.item}
                                         index={index} hiddenModal={this.hiddenModal}/>;
    }

    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            {
                <View
                    style={[{
                        //marginVertical: moderateScale(15),
                        height: moderateScale(30),
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row'
                    }]}>
                    {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                    {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                    {
                        checkIndex ?

                            <View style={{flexDirection: 'row'}}>


                                <TouchableOpacity
                                    onPress={() => {
                                        //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                        let arr = container.state.arraySelected;

                                        if (idx !== -1) {
                                            arr.splice(idx, 1)

                                            container.setState({
                                                    arraySelected: arr,
                                                    [`selectFilter${index}`]: {
                                                        value: item.name,
                                                        id: item.id,
                                                        type: item.type
                                                    },
                                                    visibleModal: '',
                                                },

                                                () => {
                                                    container.getData(1)
                                                }
                                            )
                                        }
                                        // container.setState({
                                        //         [`selectFilter${index}`]: {
                                        //             value: item.name,
                                        //             id: item.id,
                                        //             type:item.type
                                        //         },
                                        //         visibleModal: '',
                                        //     },
                                        //     () => {
                                        //         let arr = this.state.arraySelected;
                                        //         this.setState({
                                        //                 arraySelected: arr
                                        //             },
                                        //             () => {
                                        //                 container.getData(1)
                                        //             }
                                        //         )
                                        //
                                        //     }
                                        // )

                                    }}
                                    style={{
                                        alignSelf: 'center',
                                        //  marginHorizontal:moderateScale(6)
                                    }}>
                                    <HMIcon name={"md-close"} style={{
                                        fontSize: moderateScale(20),
                                        color: '#f2f2f2'
                                    }}/>

                                </TouchableOpacity>
                            </View>
                            :
                            null


                    }
                    {
                        checkIndex ?
                            <View style={{width: moderateScale(6),}}/>

                            :
                            null
                    }
                    <TouchableOpacity
                        onPress={() => {

                            this.setState({
                                    indexFilter: index,
                                    typeFilter: item.type,
                                    ["dataSource" + index]: item.list
                                },
                                () => {
                                    //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                    this.onShow('Modal')

                                })
                        }
                        }

                        style={{alignItems: 'center', flexDirection: 'row'}}
                    >

                        <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                    style={{
                                        color: checkIndex ? Colors.white : Colors.gray,
                                        //marginHorizontal: moderateScale(6),
                                        fontSize: moderateScale(11),
                                        textAlign: 'center',

                                    }}/>
                        <HMIcon name={"ios-arrow-down"} style={{
                            fontSize: moderateScale(11),
                            color: checkIndex ? '#f2f2f2' : Colors.gray,
                            marginHorizontal: moderateScale(2),
                            marginTop: moderateScale(3)
                        }}/>
                    </TouchableOpacity>


                </View>

            }
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashGetAllData.Connection) {
            this.getData(1)
        } else {
            // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlGalleryServiceScreen, `?type=${this.props.typee}&city=`, TypeGetGalleryServiceScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {

        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashGetAllData.Connection) {
            // this.props.callService(urlGalleryServiceScreen, `?type=${this.props.typee}&Condition=`, TypeGetGalleryServiceScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id,
                        value: data.name,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                //indexFilterCondition: index,
                visibleModal: '',
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }

    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;
        const newData = childFilter.list.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }


    fileSelect = async event => {
        // NavigationService.BackTo(2)

        let image = await Tools.resizeFile(event.target.files[0]);

        // this.uploadFile(image, true)

        //this.state.arrImage.push(image)

        this.setState({
            //ShowImage:true
            showModal: false,
            //pathImage: image
        })


        let {index, indexWork} = this.state;

        store.dispatch(serviceActionAddFile({
                id: 4,
                file: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/1200px-Image_created_with_a_mobile_phone.png",
                display: true
            }
            , index))

        // // this.getData()
        // const some_array = [...this.state.list]
        //
        // some_array[index].slider.push({
        //     id: 4,
        //     image: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/1200px-Image_created_with_a_mobile_phone.png",
        //     display: true
        // })
        //
        // this.setState({list: some_array, showModal: false}
        //     ,
        //     () => {

        //     }
        // )
    }

    setLike(item, index) {

        const formData = new FormData();
        formData.append('lang', i18n.locale);
        // formData.append('record', item.id);
        let id = ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) ? item.tracking_code : item.id;
        formData.append('record', id);

        formData.append('token', container.props.token);
      //  formData.append('_operation', typeExport._Registration);
        formData.append('_operation', typeExport._Contacts);
        // // formData.append('lang', params.lang);
        formData.append('mode', "LikeTicket");


        store.dispatch(serviceActionSetLike(!item.like, index, {count_like: !item.like ? item.count_like + 1 : (item.count_like === 0 ? 0 : item.count_like - 1)}))


        this.setData((res) => {
            //  store.dispatch(serviceActionSetLike(!item.like, index,res))
        }, formData, true)
        // const some_array = [...this.state.list]
        //
        // some_array[index].like = !this.state.list[index].like
        //
        // this.setState({list: some_array}
        //     ,
        //     () => {

        //     }
        // )
    }


    setData(func, formData, noLoading) {

        container.setState({
            //ShowImage:true
            isLoading: !noLoading,
            NoInternetDialog: false,

        })


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);


        axios({
            method: 'post',
            url: typeExport._baseUrlSaina,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;
                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    func ? func(data.result) : null
                    // container.getDataServerSplash()
                }
                else {
                    HMAlert(
                        i18n.t('constant.message'),
                        data.error && data.error.message ? data.error.message : data.message,
                        [
                            {
                                text: i18n.t('constant.ok'), onPress: () => {

                                }


                            },

                        ],
                        {cancelable: true}
                    )
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.status,

                })
            }).catch((e) => {
            HMAlert(
                i18n.t('constant.message'),
                "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                [
                    {
                        text: i18n.t('constant.ok'), onPress: () => {

                        }


                    },

                ],
                {cancelable: true}
            )
            container.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
            console.log('error', e)
        })
    }
}
const delayTime = 300;
let container2 = null;

class DynamicContentSlide extends React.Component {
    constructor(props) {
        super(props);
        container2 = this;
    }

    state = {
        isButtonDisplayed: true,
        firstPress: true,
        lastTime: true,
        backClickCount: 0


    };

    render() {
        const {itemSwiper, indexSwiper, onPress, onPressLike} = this.props;
        const {isButtonDisplayed, firstPress, lastTime} = this.state;
        let timer = false;
        return (
            <TouchableOpacity
                activeOpacity={1}
                onPress={onPressLike}
                style={{
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",

                    // marginHorizontal: moderateScale(4),
                    //  marginBottom:moderateScale(20),
                    //   backgroundColor:index%2===0?'#29ee0f':'#16d8ee',
                    backgroundColor: '#000',
                    //    borderTopRightRadius:moderateScale(8),
                    // borderTopEndRadius: moderateScale(12),
                    // borderTopStartRadius: moderateScale(8),

                    borderRadius: moderateScale(10),
                    overflow: "hidden"
                }}
            >
                <HMImageView
                    resizeMode={'contain'}
                    uriComplete={itemSwiper.file}
                    _backgroundColorLoading={Colors.black}
                    styleImage={{
                        //  resizeMode: 'cover',
                        width: "100%",
                        height: "100%",
                        //   backgroundColor: "#ee7e0c",
                        //  borderTopRightRadius:moderateScale(8),
                        // borderTopEndRadius: moderateScale(12),
                        // borderTopStartRadius: moderateScale(8),
                        borderRadius: moderateScale(10),

                    }}
                    //  onLoad={this._onLoad}
                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                />

                {
                    itemSwiper.title ?

                        <View
                            style={[
                                {
                                    position: 'absolute',
                                    bottom: 0,
                                    height: moderateScale(50),
                                    // height: typeExport._WIDTH / ((results.slider_height ? results.slider_height : 1.6) * 4),
                                    width: '100%',
                                    color: Colors.white,
                                    padding: moderateScale(3),
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }]}
                        >
                            <HMTextView
                                type={"bold"}

                                style={[
                                    {
                                        // position: 'absolute',
                                        //  bottom: 0,
                                        // height: moderateScale(44),
                                        // width: '100%',
                                        textAlign: "center",
                                        color: Colors.white,
                                        fontSize: moderateScale(13),
                                        //  padding: moderateScale(1),

                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                    }]}
                                numberOfLines={2}
                                text={itemSwiper.title}
                            />
                        </View>
                        : null
                }
            </TouchableOpacity>
        );
    }


}
